import React, { Component } from "react";
import "../Masters/datatables.scss"; // Importing the CSS file for styling

class Receipt extends Component {
  constructor(props) {
    super(props);
    this.printReceipt = this.printReceipt.bind(this); // Bind the method
  }

  printReceipt() {
    // Get a reference to the table you want to print
    const tableToPrint = document.getElementById("printTable");

    // Create a hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "-10000px"; // Hide the iframe off-screen
    iframe.style.left = "-10000px";
    document.body.appendChild(iframe);

    // Write the content to the iframe's document
    const iframeDoc = iframe.contentWindow || iframe.contentDocument;
    const doc = iframeDoc.document || iframeDoc;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print Table</title>
         
        </head>
        <body>
          <div>${tableToPrint.innerHTML}</div>
        </body>
      </html>
    `);
    doc.close();

    // Trigger the print functionality from the iframe
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Clean up: Remove the iframe after printing
    iframe.onload = () => {
      document.body.removeChild(iframe);
    };
  }

  render() {
    return (
      <>
        <div style={{ textAlign: "center" }}>
          <table style={{ marginLeft: "auto", marginRight: "auto" }}>
            <tr>
              <td>
                {/* Removed the print button */}
                {/* <button
                  className="btn pull-center"
                  id="print"
                  style={{
                    width: "100px",
                    backgroundColor: "#4CAF50", // Green background
                    color: "white", // White text
                    border: "none", // No border
                    borderRadius: "5px", // Rounded corners
                    padding: "10px", // Padding for better size
                    cursor: "pointer", // Pointer cursor on hover
                    fontSize: "16px", // Larger font size
                    transition: "background-color 0.3s", // Smooth transition
                  }}
                  onClick={this.printReceipt}
                >
                  Print
                </button> */}
              </td> 
            </tr>
          </table>
        </div>
        <div id="printTable">
          <div className="receipt-container">
            <header className="receipt-header">
              <p className="company-name"></p>
              <p className="company-info">Off: {this.props.number}</p>
              <img
                id="imgcompany"
                alt="Alt Name"
                className="image imgpath CToWUd"
                align="middle"
                border="0"
                src={require("./logo.jpg").default}
                style={{
                  width: "300px",
                  margin: "auto",
                  textAlign: "center",
                  border: 0,
                  outline: "none",
                  textDecoration: "none",
                  minHeight: "10px",
                  maxHeight: "100px",
                }}
              />
              <p className="company-address">
                Shop No. 17, Prerna Complex, Dhapoda Rd
                <br></br>
                Val Village Bhiwandi
              </p>
            </header>

            <div className="receipt-body">
              <p>
                <strong>Date:</strong> {this.props.date}{" "}
                <span className="receipt-no">
                  <strong>Receipt No.:</strong> {this.props.receiptno}
                </span>
              </p>
              <p>
                <strong>Name:</strong> {this.props.name}
              </p>
              <p>
                <strong>Sender Mobile No.:</strong> {this.props.sender}
              </p>
              <p>
                <strong>Receiver Mobile No.:</strong> {this.props.receiver}
              </p>
              <p>
                <strong>Account No.:</strong> {this.props.accountno}
              </p>

              <p>
                <strong>Bank Name:</strong> {this.props.bankname}
              </p>
              <p>
                <strong>Amount Rs.:</strong> {this.props.amount}
              </p>
              <p>
                <strong>Transaction Number:</strong>{" "}
                {this.props.transactioncode}
              </p>
            </div>

            <footer className="receipt-footer">
              <div className="services">
                <p>INDIA AND NEPAL MONEY TRANSFER</p>
              </div>
              <p>Loan Pe Phone · Mobile Repairing · Email Printout</p>
            </footer>
          </div>
        </div>
      </>
    );
  }
}

// Use React.forwardRef to forward the ref to the Receipt component
const ForwardedReceipt = React.forwardRef((props, ref) => (
  <Receipt {...props} ref={ref} />
));

export default ForwardedReceipt;
